/**
 * Identidade visual da Fly Now Viagens, extraída da logomarca oficial.
 * Usar estes valores em vez de cores soltas pelo código.
 *
 * Acessibilidade: o laranja da marca (#FC5A00) tem contraste baixo com fundo
 * branco para texto pequeno. Em textos, links e botões use `laranjaTexto`.
 */
export const brand = {
  marinho: '#101648',
  turquesa: '#8FCAC6',
  laranja: '#FC5A00',
  laranjaTexto: '#C2410C',
  cinza: '#606060',
} as const;

export const logos = {
  completo: '/brand/logo-completo.png',
  icone: '/brand/logo-icone.png',
  simbolo: '/brand/logo-simbolo.png',
  /** Símbolo "F" em branco e laranja, para fundos azul-marinho. */
  fClaro: '/brand/logo-f-claro.png',
} as const;
